import React, { useState } from "react";
import LoadingSpinner from "../../components/LoadingSpinner";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useNavigate } from "react-router-dom";

export default function SignOutOffAllDevices() {
  const [isLoading, setIsLoading] = useState(false);
  const [complete, setComplete] = useState(false);
  const { user, dispatch } = useAuthContext();
  const navi = useNavigate();

  const SignOutOfAll = async () => {
    setIsLoading(true);

    try {
      const response = await axios.put(
        `${ApiConnectionString}/api/User/SignOutOffAllOtherDevices`,
        null,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (response.status === 200) {
        dispatch({ type: "LOGOUT" });
        navi("/");
        setComplete(true);
      }
    } catch (error) {
      console.error("Error signing out of other devices:", error);
      // Optionally handle the error, e.g., display a notification
    } finally {
      setIsLoading(false); // Always stop loading
    }
  };

  if (isLoading) {
    return (
      <div className="container">
        <LoadingSpinner />
      </div>
    );
  } else {
    return (
      <div className="container mx-4">
        <div className="">
          <p className="settings-custom-small fw-bold mb-0">
            Sign Out Off All Devices
          </p>
        </div>
        <p>To sign this account out from all devices, press "Sign out from all." This will also log out the current session.</p>


        {complete ? (
          <p>You have successfully signed out from all devices.</p>
        ) : (
          <div>
            <div className="d-flex justify-content-end mx-5">
              <button
                className="px-3 py-2 saveChanges-button"
                onClick={SignOutOfAll}
              >
                Sign Out From All
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}
